export const isCtrlKey = (e) => {
    return e.metaKey || e.ctrlKey;
};
